import { SalesItemArray, SalesItem } from './sales.item';
import { SalesItemTotalsArray } from './sales.item.totals';

export class SalesStatisticsResult {
    SalesItems: SalesItemArray;
    ItemsTotals: SalesItemTotalsArray;
    TotalSalescount: number;
    TotalSalesAmount: number;

    ReactivationItems: SalesItemArray;
    ReactivationTotals: SalesItemTotalsArray;
    TotalReactivationCount: number;
    TotalReactivationAmount: number;

    public static FixDates(item: SalesStatisticsResult) {

        if (item.SalesItems != undefined)
            SalesItemArray.FixDates(item.SalesItems);

        if (item.ReactivationItems != undefined)
            SalesItemArray.FixDates(item.ReactivationItems);

    }
}
